export default {
	mask: Number,
	scale: 0,
	thousandsSeparator: ' ',
	radix: '.',
	mapToRadix: ['.'],
	min: 0,
	max: 999999999,
}
